<template>
  <el-dialog title="班组考勤" :visible.sync="dialogVisible" v-loading="loading" :before-close="handleClose">
    <el-form ref="info" :model="info" label-width="0px" :rules="rules">
      <div class="content">
        <div class="base_info">
          <div class="left">
            <span class="label">班组名称：</span>
            <span class="value">{{ info?.yhTeamAttendance?.teamName }}</span>
          </div>
          <div class="right">
            <span class="label">签到项目：</span>
            <span class="value">{{ info?.yhTeamAttendance?.projectName }}</span>
          </div>
        </div>
        <div class="title">签到信息</div>

        <div class="attendance_box">
          <div class="count">上班签到：{{ info?.yhTeamAttendance?.onSignNum }}人</div>
          <div class="item" v-for="(item, index) in info.onSignRecords" :key="index">
            <div class="img">
              <el-image :src="item.signImage" :preview-src-list="[item.signImage]" fit="fill" ref="preview">
              </el-image>
            </div>
            <div class="item_info">
              <div class="line flex">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/sign_count.svg"></div>
                  签到人数：
                </div>
                <el-form-item :prop="'onSignRecords.' + index + '.signNum'" :rules='rules.signNum'>
                  <el-input v-model.number="item.signNum"></el-input>
                </el-form-item>
                人
              </div>
              <div class="line">
                <div class="label">
                  <div class="sign_img"><img :src='imgSrc(item.resignFlag)'></div>
                  上班签到：
                </div>
                <span class="value">{{ item.signTime }}</span>
              </div>
              <div class="line">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/sign_address.svg"></div>
                  签到地点：
                </div>
                <span class="value">{{ item.signAddress }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="attendance_box" v-if="info?.offSignRecords?.length">
          <div class="count">下班签到：{{ info?.yhTeamAttendance?.offSignNum }}人</div>
          <div class="item" v-for="(item, index) in info.offSignRecords" :key="index">
            <div class="img">
              <el-image :src="item.signImage" :preview-src-list="[item.signImage]" fit="fill" ref="preview">
              </el-image>
            </div>
            <div class="item_info">
              <div class="line flex">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/sign_count.svg"></div>
                  签到人数：
                </div>
                <el-form-item :prop="'offSignRecords.' + index + '.signNum'" :rules='rules.signNum'>
                  <el-input v-model.number="item.signNum"></el-input>
                </el-form-item>
                人
              </div>
              <div class="line">
                <div class="label">
                  <div class="sign_img"><img :src='imgSrc(item.resignFlag)'></div>
                  下班签到：
                </div>
                <span class="value">{{ item.signTime }}</span>
              </div>
              <div class="line">
                <div class="label">
                  <div class="sign_img"><img src="@/assets/img/attendance/sign_address.svg"></div>
                  签到地点：
                </div>
                <span class="value">{{ item.signAddress }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-form-item>
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="saveForm" :disabled='submitShow'>确认</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'WorkerListDetails',
  props: {
    id: {
      type: String,
      default: ''
    },
    correctShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      loading: false,
      submitShow: false,

      rules: {
        signNum: [
          { required: true, message: '输入1-99数字', trigger: ['change', 'blur'], pattern: /^[1-9][0-9]{0,1}$/ }
        ]
      },

      info: {
        yhTeamAttendance: {},
        onSignRecords: [],
        offSignRecords: [],
        overtimeRecords: []
      }
    }
  },
  watch: {
    correctShow (val) {
      this.dialogVisible = val
      val && this.getDetail()
    }
  },
  methods: {
    getDetail () {
      // this.loading = true
      this.$axios.get(this.$apis.laborManage.selectYhTeamAttendanceDetail, { attendanceId: this.id }).then(res => {
        if (res) {
          this.info = res
        }
      }).finally(() => {
        // this.loading = false
      })
    },

    saveForm () {
      this.$refs.info.validate((valid) => {
        if (valid) {
          // console.log('通过校验')
          let params = []
          params = [...this.info.onSignRecords, ...this.info.offSignRecords]
          params = params.map((item) => {
            return {
              signId: item.signId,
              signNum: item.signNum
            }
          })
          this.submitShow = true
          this.$axios.post(this.$apis.laborManage.updateTeamSignNum, params).then(() => {
            this.$message.success('保存成功')
            this.handleClose()
            this.$emit('success')
          }).finally(() => {
            this.submitShow = false
          })
        }
      })
    },

    imgSrc (val) {
      // console.log('图片处理', val)
      if (val) {
        if (val === 'Y') {
          return require('@/assets/img/attendance/card_replacement.svg')
        } else {
          return require('@/assets/img/attendance/sign.svg')
        }
      }
    },

    handleClose () {
      // console.log('关闭弹窗')
      this.$emit('update:correctShow', false)
      this.info = {
        yhTeamAttendance: {},
        onSignRecords: [],
        offSignRecords: [],
        overtimeRecords: []
      }
    }
  }

}
</script>

<style scoped lang="scss">
::v-deep .el-dialog {
  border-radius: 10px;
  width: 761px;
  height: 680px;
}

.el-image {
  width: 100%;
  height: 100%;
}

::v-deep .el-input__inner {
  width: 80px;
}

::v-deep .el-form-item {
  margin-bottom: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.flex {
  display: flex;
}

.content {
  padding: 10px;
  font-size: 12px;
  height: 530px;
  overflow-y: auto;
  overflow-x: hidden;

  .base_info {
    line-height: 30px;
    display: flex;
    font-size: 14px;

    .left,
    .right {
      display: flex;

      .label {
        width: 80px;
      }

      .value {
        flex: 1;
      }
    }

    .left {
      width: 200px;
    }

    .right {
      flex: 1;
    }
  }

  .title {
    line-height: 50px;
    font-size: 14px;
  }

  .attendance_box {
    width: 700px;
    min-height: 264px;
    padding: 20px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    margin-bottom: 30px;

    .item {
      // width: ;
      height: 214px;
      // background-color: skyblue;
      margin-bottom: 30px;
      display: flex;

      .img {
        width: 214px;
        height: 214px;
        background-color: yellowgreen;
        margin-right: 47px;
      }

      .item_info {
        flex: 1;
      }

      .line {
        line-height: 50px;
        display: flex;

        .label {
          width: 95px;
          height: 50px;
          display: flex;
          align-items: center;

          .sign_img {
            width: 20px;
            justify-content: center;
            display: flex;
            align-items: center;
            margin-right: 5px;
            // height: 20px;
          }
        }

        .value {
          flex: 1;
          line-height: 50px;
        }
      }
    }

    .count {
      line-height: 40px;
      font-size: 13px;
    }

    .correct {
      padding-left: 10px;
      color: #1DCFAF;

      p {
        margin-bottom: 5px;

        span {
          margin-right: 10px;
        }
      }
    }

    .line_height30 {
      line-height: 30px !important;
    }

    .item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
